import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../databaseServices/BaseDatabaseService';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EmailTable} from '../../classes/EmailTable';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type':  'application/json'
      // 'Authorization': 'my-auth-token'
    }
  )
};

@Injectable({
  providedIn: 'root'
})
export class EmailService extends BaseDatabaseService{

  private static SEND_EMAIL_LOCAL = 'http://localhost:5001/time4race-6be4a/us-central1/sendMail';
  private static SEND_EMAIL = 'https://us-central1-time4race-6be4a.cloudfunctions.net/sendMail';

  constructor(private httpClient: HttpClient) {
    super();
  }

  sendEmail(fromEmail: string, toEmail: string, subject: string, message: string) {
    const url = EmailService.RUN_LOCAL ? EmailService.SEND_EMAIL_LOCAL : EmailService.SEND_EMAIL;
    const body = {
      fromEmail: fromEmail,
      toEmail: toEmail,
      subject: subject,
      message: message
    };
    return this.httpClient.post(url, body, httpOptions).toPromise();
  }
}
